import { SectionHeading } from "@/components/shared/SectionHeading";
import { RevealStagger, RevealItem, Reveal } from "@/components/shared/Reveal";
import { ArrowRight, Link2, Radio } from "lucide-react";
import { openPreRegister } from "@/lib/preRegisterModal";

const CARRIER_FUNCTIONS = [
  "Post assignments", "Find drivers", "Search by qualifications", "Search by location", "Review HOS availability",
  "Track active assignments", "Request relief drivers", "Manage handoffs", "Monitor fleet activity",
  "Manage secured driver compensation", "Review delivery evidence", "Manage documents", "Review claims",
];

const ELD_DATA = [
  "Duty status", "Driving time remaining", "Duty window remaining", "Cycle availability", "Break information",
  "HOS logs", "Vehicle association", "Diagnostic status", "Last synchronization",
];

export const Carriers = () => {
  return (
    <section id="carriers" data-testid="carriers-section" className="py-24 md:py-32 bg-rr-surface">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid lg:grid-cols-[0.9fr_1.1fr] gap-16 items-start">
          <div>
            <SectionHeading
              eyebrow="For Carriers"
              title="Driver Coverage When Your Operation Needs It."
              testId="carriers"
            />
            <Reveal delay={0.3}>
              <button onClick={() => openPreRegister("carrier")} data-testid="join-as-carrier-cta" className="mt-9 inline-flex items-center gap-2 bg-rr-orange text-white font-bold px-7 py-4 rounded-full hover:bg-rr-navy transition-all hover:-translate-y-1">
                Request Carrier Early Access <ArrowRight size={18} />
              </button>
              <p data-testid="return-trip-policy-note" className="mt-4 text-xs text-rr-muted max-w-sm">
                Requesting relief drivers? Your compensation must include funding their way home — RelayRigs does not book or provide that travel.
              </p>
            </Reveal>
          </div>
          <RevealStagger className="grid sm:grid-cols-2 gap-3">
            {CARRIER_FUNCTIONS.map((f) => (
              <RevealItem key={f}>
                <div data-testid={`carrier-function-${f.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="bg-white border border-rr-line rounded-lg px-4 py-3 text-sm font-semibold text-rr-navy">
                  {f}
                </div>
              </RevealItem>
            ))}
          </RevealStagger>
        </div>

        <div className="mt-24 border border-rr-line rounded-[2rem] p-8 md:p-12 bg-rr-navy text-white relative overflow-hidden">
          <div className="grain-overlay" />
          <div className="grid md:grid-cols-[1fr_1fr] gap-10 relative">
            <div>
              <div className="flex items-center gap-2 text-rr-orangeLight text-xs font-bold tracking-[0.2em] uppercase mb-4">
                <Link2 size={14} /> ELD Integration
              </div>
              <h3 className="font-heading text-3xl font-bold">Connect the ELD You Already Use.</h3>
              <p className="mt-4 text-white/60 text-sm leading-relaxed max-w-md">
                Commercial drivers should not need to abandon their existing ELD simply to use RelayRigs. The driver authorizes their provider connection rather than giving RelayRigs their ELD password.
              </p>
              <p className="mt-4 text-xs text-white/40">FMCSA Registered / Self Certified ELD, where applicable.</p>
            </div>
            <div className="grid grid-cols-2 gap-2.5 content-start">
              {ELD_DATA.map((d) => (
                <div key={d} data-testid={`eld-data-${d.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="flex items-center gap-2 bg-white/[0.06] border border-white/10 rounded-lg px-3 py-2.5 text-xs font-semibold">
                  <Radio size={13} className="text-rr-orangeLight shrink-0" /> {d}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
